export default __webpack_public_path__ + "static/media/q2_answer.8d13e20b.jpg";